<template>
  <div class='mux-live-stream-video-player-container' :class="{'embed-responsive-item': dashboardPlayer}" ref="liveStreamVideoPlayerContainer"> 
    <!-- <video ref="mux-player" class="video-js" :playerId="playerId"></video> -->
    <img 
      :src="liveStream.poster_url" 
      class='poster-image' 
      v-if="liveStream && liveStream.poster_url" 
      v-show="liveStream && liveStream.poster_url && !active"
    />
    <div v-show="liveStreamFetched && !liveStream.poster_url && !active" class="alert alert-info">
      <i class="fa fa-info-circle"></i>
      <h6>{{ liveStream.status }}</h6>
    </div>
    <div v-show="liveStreamFetchError" class="alert alert-danger">
      <i class="fa fa-info-circle"></i>
      <h6>{{ liveStreamFetchError }}</h6>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import videojs from '@mux/videojs-kit';
  import '@mux/videojs-kit/dist/index.css';

  export default {

    props: {
      eventId: {
        type: Number,
        required: false,
      },
      liveStreamId: {
        type: [Number, String],
        required: false
      },
      liveStreamm: {
        type: Object,
        default: function () {
          return {};
        }
      },
      dashboardPlayer: {
        type: Boolean,
        default: false
      },
      viewerUserId: {
        type: [String, Number],
        default: 'NOT_PROVIDED'
      },
      dashboardViewer: {
        Type: Boolean,
        default: false
      },
      queuedConductor: {
        type: Boolean,
        default: false
      }
    },

    data: function () {
      return {
        liveStreamFetchError: false,
        fetchingStream: false,
        playerInitialized: true,
        liveStream: Object.assign({status: 'idle'}, this.liveStreamm),
        liveStreamFetched: !!Object.keys(this.liveStreamm).length || false
      }
    },

    methods: {
      fetchLiveStream () {
        this.fetchingStream = true
        var _url = this.dashboardViewer
          ? `/events/${this.eventId}/live-streams/${this.liveStreamId}?ajax=1`
          : `/live-streams/${this.liveStreamId}?ajax=1`


        axios.get(_url)
          .then(response => {
            this.liveStream = response.data
            this.liveStreamFetched = true
          })
          .catch(error => {
            this.liveStreamFetchError = error
            console.error(error.response)
          })
          .then(() => {
            this.fetchingStream = false
          });
      },

      addVideoPlayerToDOM () {
        var videoPlayerContainer = this.$refs.liveStreamVideoPlayerContainer
        var videoPlayer = document.createElement('video');
        videoPlayer.id = this.playerId;
        videoPlayer.classList.add('video-js');
        videoPlayer.classList.add('vjs-big-play-centered');
        videoPlayer.classList.add(`vjs-theme-${this.theme}`);
        videoPlayer.classList.add('vjs-fluid');
        videoPlayer.setAttribute('muted', true);
        videoPlayer.setAttribute('preload', 'auto')
        videoPlayer.setAttribute('controls', true)
        videoPlayer.setAttribute('playsinline', true)
        videoPlayerContainer.appendChild(videoPlayer);
      },      

      joinLiveStreamUpdatePusherChannel () {
        console.log('joining player live stream update channel')
        window.Echo.channel('live-streams.' + this.liveStream.id)
          .listen('LiveStreamUpdated', function receivedMesssge (e) {
            this.liveStream = Object.assign(this.liveStream, e.liveStream)
          }.bind(this));
      },

      getPlayer () {
        return videojs(`#${this.playerId}`)
      },

      removePlayer () {
        if (this.getPlayer()) {
          this.getPlayer().dispose()
        }
      },

      getSetupConfig () {
        return {
          muted: true,
          responsive: true,
          plugins: {
            mux: {
              debug: false,
              data: {
                env_key: process.env.MIX_MUX_ENV_KEY, // required
                viewer_user_id: this.viewerUserId, // should switch to something else but want to make clear metrics work but came from admin
                video_title: this.liveStream.name,
                video_id: 'liveStream-'+this.liveStream.id
              }
            }
          }
        }        
      },

      initMuxPlayer () {
        this.addVideoPlayerToDOM()
        var player = videojs(`#${this.playerId}`, this.getSetupConfig());
        this.playerInitialized = true;

        var playerSrc = this.playbackIds[0].id

        if (this.liveStream.signed) {
          playerSrc = `${playerSrc}?token=${this.liveStream.playback_token}`
        }

        player.src({
          src: playerSrc,
          type: "video/mux"
        });

        player.on('ready', function() {
          console.log('player ready');
          player.play(function success () {
            console.log('player played');
          }.bind(this), function error () {
            console.log('player error');
          }.bind(this));
        }.bind(this));

        player.on('error', function() {
          console.log('error looking')
          // var errorThree = player?.error()?.code == 3 
          var nonFatal = player.error()?.hlsError && !player.error().hlsError.fatal
          if (nonFatal) { 
            console.log('non-fatal error', player.error());
            player.error(null);
            return
          }
          console.log('fatal error', player.error());
        });        
      },
    },

    watch: {
      'liveStream.status': function(newValue, oldValue) {
        console.log('livestream.status --- ', newValue)
        var shouldPlay = oldValue !== newValue && newValue === 'active'
        if (oldValue == 'complete') shouldPlay = false 
        if (shouldPlay) {
          console.log('init mux player')
          this.initMuxPlayer();
        }
        if (oldValue !== newValue && ['idle', 'complete'].includes(newValue)) {
          this.removePlayer()
        }        
      },

      liveStreamFetched: function(newValue, oldValue) {
        if (newValue) {
          this.joinLiveStreamUpdatePusherChannel();
        }
      },
    },

    computed: {

      playerId () {
        return `mux-player-${this.liveStream.id}-${this.queuedConductor ? 'conductor' : 'viewer'}`
      },

      active () {
        return this.liveStreamFetched 
          && this.liveStream
          && this.liveStream.status === 'active'
      },

      playbackIds: function () {
        if (!this.liveStream?.playback_ids) {
          return []
        };
        return JSON.parse(this.liveStream.playback_ids);
      },
    },


    mounted: function () {
      this.fetchLiveStream()

      // hack to make it work when livestream passed in for viewing on dashboard, should maybe just use different plater
      if (this.liveStreamFetched) {
        this.liveStreamFetched = false
        this.$nextTick(() => {
          this.liveStreamFetched = true
        })        
      }
      // hack to make it work when livestream passed in for viewing on dashboard, should maybe just use different plater
      if (this.liveStream.status == 'active') {
        this.liveStream.status = 'idle'
        this.$nextTick(() => {
          this.liveStream.status = 'active'
        })
      }
      window.attendeeLiveStream = this
      window.videojstest = videojs
    },

    beforeUnmount: function () {
      this.removePlayer()
    },

    beforeDestroy: function () {
      this.removePlayer()
    }
  }
</script>

<style>

  /* shared with MuxAttendeeVideoPlayer */
  .mux-video-player-container,
  .mux-live-stream-video-player-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;
  }

  .poster-image {
    width: 100%;
    height: auto;
  }

</style>